module.exports = __webpack_public_path__ + "static/media/skrivehastighetIntroExtended.4526ea8f.mp3";